import React from 'react';
import { observer, inject } from 'mobx-react';
import CodeElement from './CodeElement';
import WeaWfInput from '../../public/wf-form-input/index';
import { showPrompt } from '../../util/formUtil';
import * as _ from '../../util/public/common';

@inject('layoutStore')
@observer
export default class InputElement extends React.Component{
    doChangeEvent = (value) => {
        const { layoutStore,fieldMark } = this.props;
		layoutStore.changeSingleFieldValue(fieldMark, {value: value});
    }
    doDisablePromptEvent = () => {
        const { fieldMark } = this.props;
        showPrompt(fieldMark, 2);
    }
    render() {
        const { layoutStore,fieldMark,fieldAttr,symbol,rowIndex,cellObj,fieldObj } = this.props;
        let { baseProps} = this.props;
        const { variable } = fieldObj;
        const specialobj  = fieldObj.specialobj ? mobx.toJS(fieldObj.specialobj) : {};
        const fieldid = baseProps.fieldid;
        //判断是否为流程编号
        const { codeInfo,linkageCfg, propFileCfg={} } = layoutStore;
        const { closeAutoComplete, autocomplete_change_name = '0' } = propFileCfg;
        const { isUse,fieldCode } = codeInfo;
        if(isUse && fieldCode === fieldid){
            return <CodeElement ecId={`${this && this.props && this.props.ecId || ''}_CodeElement@2bygal`} {...this.props} />
        }
        //扩展组件参数
        if(baseProps.viewAttr !== 1){   //文本类型字段空值显示的默认值
            baseProps.emptyShowContent = variable.get("emptyShowContent") || "";
        }
        if("showhtml" in specialobj){
            baseProps.showhtml = specialobj.showhtml;   //文本显示值
        }
        const { qfws,length,detailtype  } = fieldAttr;
        let format = cellObj.format || {};
        const transtype = parseInt(_.get(linkageCfg, ["transTypeCfg", fieldid]) || 0);   //字段赋值转格式，模拟用格式化实现
        const enableInput = !this.judgeBelRowCalAssignField();      //判断当前字段是否为行规则计算赋值字段，不允许修改
        if(transtype === 1){    //转金额大写
            format = { numberType:101 };
        }else if(transtype === 2){      //转金额千分位，模拟数值格式化
            format = { numberType:2, decimals:qfws, formatPattern:2, thousands:1 };
        }
        if("financial" in cellObj){      //财务格式优先级最高
            const financial = cellObj.financial || "";
            if(financial.indexOf("2-") > -1){
                const finaNum = parseInt(financial.split("-")[1] || "3");
                format = { numberType:100, finaNum:finaNum };
            }else if(financial === "3"){        //转金额大写
                format = { numberType:101 };
            }else if(financial === "4"){        //转金额千分位，模拟数值格式化两位
                if(detailtype == 1){
                    format = { numberType:2, decimals:2, formatPattern:2, thousands:1 };
                }else{
                    format = {numberType: 2, decimals: qfws, formatPattern: 2, thousands: 1};
                }
            }
        }
        return(
            <WeaWfInput ecId={`${this && this.props && this.props.ecId || ''}_WeaWfInput@kl6eki`} 
                length={length}
                qfws={qfws}
                onChange={this.doChangeEvent}
                format={format}
                enableInput={enableInput}
                onDisablePrompt={this.doDisablePromptEvent}
                {...baseProps}
                closeAutoComplete={closeAutoComplete}
                autocomplete_change_name={autocomplete_change_name}
            />
        )
    }
    //判断字段是否属于明细行规则赋值字段
    judgeBelRowCalAssignField(){
        const { layoutStore,baseProps,fieldAttr } = this.props;
        const { linkageCfg,cellInfo } = layoutStore;
        const fieldid = baseProps.fieldid;
        if(!baseProps.isDetail || !_.has(linkageCfg, ["rowCalCfg", "rowCalAssignInfo", fieldid]))
            return false;
        let isValid = true;
        _.get(linkageCfg, ["rowCalCfg", "rowCalAssignInfo", fieldid]).map(id =>{
            if(!_.has(cellInfo, ["fieldCellInfo", id]) || fieldAttr.viewattr <= 0)
                isValid = false;    //取值字段不在模板上认为是无效行规则
        });
        return isValid;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/fieldType/InputElement.js